import { defineComponent, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from 'vue';
import { ark } from '../factory.js';
import { useSelectContext } from './use-select-context.js';
import { useSelectItemPropsContext } from './use-select-item-props-context.js';
import { useForwardExpose } from '../../utils/use-forward-expose.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "select-item-indicator",
  props: {
    asChild: { type: Boolean }
  },
  setup(__props) {
    const select = useSelectContext();
    const itemProps = useSelectItemPropsContext();
    useForwardExpose();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ark).div, mergeProps(unref(select).getItemIndicatorProps(unref(itemProps)), { "as-child": _ctx.asChild }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["as-child"]);
    };
  }
});

export { _sfc_main as default };
